// Resolve a product's MSRP already expressed in the selected currency.
// Matches the resolution order used by ProductDetail and calculateSalePrice:
// region_prices[regionCode] (US/CA) -> region_prices[currency] (USD/CAD) -> product.price.
// The returned value is ALREADY in the selected currency — format it with
// CurrencyContext.formatMoney (NOT formatPrice, which would re-convert).
const REGION_CODE_MAP = { USD: 'US', CAD: 'CA', EUR: 'EUR' };

export const getRegionPrice = (product, currency = 'CAD') => {
  if (!product) return 0;
  const regionCode = REGION_CODE_MAP[currency] || currency;
  const rp = product.region_prices || {};
  const value = rp[regionCode] ?? rp[currency] ?? product.price ?? 0;
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

export default getRegionPrice;
